export default "__VITE_ASSET__3a1250cb__"